import * as React from 'react';

const Logotype = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1888 504"
    preserveAspectRatio="xMidYMid meet"
    {...props}
    fill="white"
  >
    <g transform="translate(0,504) scale(0.1,-0.1)" stroke="none">
      {/* Q */}
      <path
        d="M1396 5029 c-605 -64 -1123 -479 -1315 -1056 -54 -164 -75 -297 -75
          -488 0 -202 17 -315 75 -488 189 -573 680 -980 1274 -1058 143 -18 416 -6 545
          24 186 44 369 121 500 211 l65 44 148 -146 147 -147 177 178 178 177 -147 147
          -146 148 39 58 c57 82 133 238 170 348 54 161 70 257 76 454 6 208 -12 346
          -68 521 -224 701 -912 1150 -1643 1073z m416 -523 c374 -95 669 -388 770 -764
          26 -99 36 -321 18 -429 -65 -406 -381 -752 -779 -854 -402 -103 -830 40 -1088
          365 -298 375 -307 903 -23 1286 159 213 409 369 660 410 41 6 82 13 90 15 46
          12 263 -6 352 -29z"
        fill="#EB618F"
      />
      {/* u */}
      <path
        d="M3482 3288 c4 -677 4 -684 27 -758 39 -131 96 -225 191 -321 73 -74
          100 -93 190 -138 319 -157 693 -139 953 45 26 19 49 34 52 34 3 0 5 -29 5 -65
          l0 -65 235 0 235 0 -2 973 -3 972 -232 3 -233 2 0 -600 c0 -687 -1 -696 -74
          -803 -48 -70 -138 -137 -219 -163 -67 -21 -237 -30 -308 -15 -140 29 -248 110
          -306 229 l-38 76 -3 638 -3 638 -235 0 -235 0 3 -682z"
      />
      {/* e */}
      <path
        d="M6522 4009 c-363 -47 -657 -259 -787 -568 -66 -157 -80 -234 -79
          -451 0 -179 2 -203 27 -295 114 -424 436 -682 904 -726 343 -32 672 86 895
          320 102 106 184 242 222 369 l7 22 -239 0 -240 0 -13 -32 c-19 -46 -125 -155
          -193 -200 -95 -61 -201 -91 -326 -91 -91 0 -117 4 -192 30 -191 66 -326 217
          -372 414 l-14 59 797 0 798 0 21 23 c19 20 22 35 22 98 0 627 -428 1045 -1065
          1038 -60 -1 -138 -5 -173 -10z m321 -394 c157 -33 300 -142 371 -282 20 -40
          36 -75 36 -78 0 -3 -245 -5 -545 -5 -367 0 -545 3 -545 10 0 6 14 39 31 73 40
          77 154 194 228 231 120 61 283 81 424 51z"
      />
      {/* s */}
      <path
        d="M8540 4005 c-385 -64 -610 -310 -587 -640 11 -154 69 -254 194 -335
          118 -77 303 -141 579 -200 242 -52 355 -93 412 -149 27 -28 32 -40 32 -79 -1
          -127 -124 -215 -340 -243 -179 -22 -348 22 -451 118 -55 51 -85 100 -97 160
          l-8 38 -221 3 -221 2 5 -47 c43 -440 471 -715 1033 -663 166 15 294 49 419
          111 85 42 118 65 180 128 120 119 171 238 171 403 0 328 -185 480 -745 608
          -184 42 -338 86 -385 110 -76 39 -108 106 -79 163 71 139 334 181 526 83 44
          -22 134 -107 158 -149 9 -17 25 -14 220 33 115 28 211 53 213 55 8 7 -40 100
          -82 159 -108 151 -278 263 -485 318 -100 26 -322 33 -441 13z"
      />
      {/* t */}
      <path
        d="M10090 4330 l0 -359 -152 -3 -153 -3 -3 -192 -2 -193 154 0 155 0 3
          -582 c4 -570 4 -584 26 -649 61 -182 200 -305 409 -360 131 -35 362 -29 506
          13 l37 11 0 169 0 168 -171 0 c-93 0 -190 5 -214 11 -54 14 -111 72 -120 121
          -3 18 -4 272 -3 563 l3 530 243 3 242 2 0 195 0 195 -245 0 -245 0 0 360 0
          360 -235 0 -235 0 0 -360z"
      />
      {/* . */}
      <path
        d="M11420 2275 l0 -255 255 0 255 0 0 255 0 255 -255 0 -255 0 0 -255z"
        fill="#EB618F"
      />
      {/* underline */}
      <path
        d="M11430 1481 c0 -104 31 -282 70 -401 269 -821 1146 -1267 1964 -999
          614 201 1023 732 1071 1392 l6 87 -249 0 -249 0 -11 -102 c-55 -500 -429 -882
          -929 -949 -379 -50 -798 148 -1008 476 -100 156 -146 296 -170 518 l-6 57
          -245 0 -244 0 0 -79z"
        fill="#EB618F"
      />
      {/* e */}
      <path
        d="M13028 4005 c-348 -55 -606 -239 -748 -536 -131 -275 -133 -666 -5
          -946 130 -283 387 -475 721 -539 120 -23 350 -23 459 1 271 58 479 186 637
          395 49 64 131 219 144 273 l6 27 -238 0 -239 0 -25 -46 c-31 -59 -122 -150
          -192 -192 -337 -201 -764 -41 -872 327 -30 102 -124 91 777 91 701 0 795 2
          815 16 20 14 22 23 22 112 0 310 -101 566 -296 753 -87 83 -142 120 -257 174
          -199 94 -465 128 -709 90z m344 -390 c107 -22 194 -69 269 -144 61 -61 118
          -146 134 -198 l6 -23 -545 0 c-393 0 -546 3 -546 11 0 6 14 39 32 73 40 75
          154 191 225 229 115 61 284 82 425 52z"
      />
      {/* d */}
      <path
        d="M16170 4224 l0 -466 -37 32 c-172 144 -402 230 -618 230 -362 0 -668
          -149 -848 -414 -230 -339 -234 -873 -8 -1217 124 -188 326 -329 556 -388 299
          -76 590 -32 823 123 37 24 78 56 91 70 14 14 28 26 33 26 4 0 8 -45 8 -100 l0
          -100 230 0 230 0 0 1335 0 1335 -230 0 -230 0 0 -466z m-429 -639 c199 -52
          349 -206 405 -415 23 -88 23 -263 1 -350 -58 -221 -208 -371 -427 -426 -88
          -22 -281 -15 -360 14 -211 75 -341 222 -384 434 -60 290 55 572 281 690 144
          76 320 95 484 53z"
      />
      {/* u */}
      <path
        d="M16994 3956 c-3 -7 -4 -312 -2 -677 4 -605 6 -670 22 -729 66 -233
          200 -392 419 -495 146 -70 376 -106 535 -85 153 20 302 79 400 157 l42 34 0
          -70 0 -71 235 0 235 0 0 975 0 975 -235 0 -234 0 -3 -632 -3 -633 -23 -58
          c-45 -111 -130 -192 -251 -238 -41 -16 -86 -23 -166 -26 -122 -6 -200 9 -288
          54 -60 30 -138 105 -166 161 -50 98 -51 114 -51 764 l0 608 -230 0 c-186 0
          -232 -3 -236 -14z"
      />
    </g>
  </svg>
);

export default Logotype;
